<div class="layout-selector d-flex">
  <div class="layout-icon list" [class.active]="value === 'list'" [class.arabic]="currentLanguage === 'ar'" (click)="writeValue('list')">
    <svg-icon key="list-view"></svg-icon>
  </div>
  <div class="layout-icon grid" [class.active]="value === 'grid'" [class.arabic]="currentLanguage === 'ar'" (click)="writeValue('grid')">
    <svg-icon key="grid-view"></svg-icon>
  </div>
</div>
